// // src/pages/FeaturedPage.jsx
// import React, { useEffect, useRef, useState } from "react";
// import Section from "../components/Section.jsx";
// import EventCardNew from "../components/EvetCardNew.jsx";
// import { apiFeaturedAll } from "../api/events.js";
// import { get } from "../lib/http";
// import { API } from "../config/api";
// import FancyLoader from "../components/FancyLoader.jsx"; // ⬅️ same loader as CheckoutPage

// export default function FeaturedPage() {
//   const [items, setItems] = useState([]);
//   const [loading, setLoading] = useState(true);     // first mount loader
//   const [fetching, setFetching] = useState(false);  // subsequent refetch overlay

//   const [filters, setFilters] = useState({
//     category: "",
//     status: "",    // "upcoming" | "past" | ""
//     city: "",
//     search: "",
//     fromDate: "",
//     toDate: "",
//   });

//   // ------- Dynamic categories -------
//   const [categories, setCategories] = useState([]);
//   const [catLoading, setCatLoading] = useState(false);

//   useEffect(() => {
//     let alive = true;
//     (async () => {
//       try {
//         setCatLoading(true);
//         const token = JSON.parse(localStorage.getItem("bb_user"))?.token;
//         const res = await get(API.category.category, {
//           headers: {
//             Authorization: token ? `Bearer ${token}` : undefined,
//             "Content-Type": "application/json",
//           },
//         });
//         if (!alive) return;
//         const list = Array.isArray(res?.categories) ? res.categories : [];
//         const normalized = list.map((c) => ({
//           id: c._id,
//           name: c.name || c.title || c.slug || "Unnamed",
//           value: c._id, // change to c.name/slug if backend expects that
//         }));
//         setCategories(normalized);
//       } catch (err) {
//         console.error("categoryList error:", err);
//         setCategories([]);
//       } finally {
//         setCatLoading(false);
//       }
//     })();
//     return () => { alive = false; };
//   }, []);

//   // ------------- SINGLE debounced fetch effect (initial + subsequent) -------------
//   const reqSeqRef = useRef(0);

//   useEffect(() => {
//     const t = setTimeout(async () => {
//       const mySeq = ++reqSeqRef.current;
//       if (reqSeqRef.current === 1) setLoading(true);
//       setFetching(true);

//       try {
//         const payload = {
//           ...filters,
//           status: (filters.status || "").toLowerCase(), // ensure backend-friendly
//         };
//         const data = await apiFeaturedAll(payload);

//         if (mySeq !== reqSeqRef.current) return; // stale response guard
//         setItems(Array.isArray(data) ? data : []);
//       } catch (e) {
//         if (mySeq === reqSeqRef.current) {
//           console.error("Filter/search fetch failed:", e);
//           setItems([]);
//         }
//       } finally {
//         if (mySeq === reqSeqRef.current) {
//           setFetching(false);
//           setLoading(false);
//         }
//       }
//     }, 400);

//     return () => clearTimeout(t);
//   }, [filters]);

//   // ---------------- handlers ----------------
//   const handleFilterChange = (name, value) => {
//     setFilters((prev) => ({ ...prev, [name]: value }));
//   };

//   const clearFilters = () => {
//     setFilters({
//       category: "",
//       status: "",
//       city: "",
//       search: "",
//       fromDate: "",
//       toDate: "",
//     });
//   };

//   // ---------------- UI ----------------
//   // FULL-PAGE loader on first mount (same feel as CheckoutPage)
//   if (loading && !items.length) {
//     return (
//       <main className="w-full px-4 py-10 grid place-items-center">
//         <FancyLoader label="Processing..." />
//       </main>
//     );
//   }

//   return (
//     <Section title="Featured Events" fullBleed bgClass="bg-[#fff8e1]">
//       <div className="flex gap-6">
//         {/* Sidebar Filters */}
//         <aside className="w-72 bg-white rounded-xl shadow p-4 hidden md:block">
//           <div className="flex items-center justify-between mb-3">
//             <h3 className="font-semibold">Filters</h3>
//             <button
//               onClick={clearFilters}
//               className="text-xs text-blue-600 hover:underline"
//             >
//               Clear
//             </button>
//           </div>

//           {/* Search */}
//           <div className="mb-4">
//             <label className="block text-sm font-medium mb-1">Search</label>
//             <div className="relative">
//               <input
//                 type="text"
//                 placeholder="Event, organizer, etc."
//                 value={filters.search}
//                 onChange={(e) => handleFilterChange("search", e.target.value)}
//                 className="w-full border rounded-lg px-3 py-2 pr-9"
//               />
//               {/* small spinner in input while refetching */}
//               {fetching && (
//                 <div className="absolute right-2 top-1/2 -translate-y-1/2">
//                   <div className="animate-spin h-4 w-4 border-2 border-slate-400 border-t-transparent rounded-full" />
//                 </div>
//               )}
//             </div>
//           </div>

//           {/* Category (dynamic) */}
//           <div className="mb-4">
//             <label className="block text-sm font-medium mb-1">Category</label>
//             <div className="relative">
//               <select
//                 value={filters.category}
//                 onChange={(e) => handleFilterChange("category", e.target.value)}
//                 className="w-full border rounded-lg px-3 py-2 pr-9"
//                 disabled={catLoading}
//               >
//                 <option value="">{catLoading ? "Loading..." : "All"}</option>
//                 {categories.map((c) => (
//                   <option key={c.id} value={c.value}>
//                     {c.name}
//                   </option>
//                 ))}
//               </select>
//               {catLoading && (
//                 <div className="absolute right-2 top-1/2 -translate-y-1/2">
//                   <div className="animate-spin h-4 w-4 border-2 border-slate-400 border-t-transparent rounded-full" />
//                 </div>
//               )}
//             </div>
//             {!catLoading && !categories.length && (
//               <p className="mt-1 text-xs text-slate-500">No categories found.</p>
//             )}
//           </div>

//           {/* Status */}
//           <div className="mb-4">
//             <label className="block text-sm font-medium mb-1">Status</label>
//             <select
//               value={filters.status}
//               onChange={(e) => handleFilterChange("status", e.target.value)}
//               className="w-full border rounded-lg px-3 py-2"
//             >
//               <option value="">All</option>
//               <option value="upcoming">Upcoming</option>
//               <option value="past">Past</option>
//             </select>
//           </div>

//           {/* Date range */}
//           <div className="mb-4">
//             <label className="block text-sm font-medium mb-1">From Date</label>
//             <input
//               type="date"
//               value={filters.fromDate}
//               onChange={(e) => handleFilterChange("fromDate", e.target.value)}
//               className="w-full border rounded-lg px-3 py-2"
//             />
//             <label className="block text-sm font-medium mt-2 mb-1">To Date</label>
//             <input
//               type="date"
//               value={filters.toDate}
//               onChange={(e) => handleFilterChange("toDate", e.target.value)}
//               className="w-full border rounded-lg px-3 py-2"
//             />
//           </div>

//           {/* City */}
//           <div className="mb-2">
//             <label className="block text-sm font-medium mb-1">City</label>
//             <input
//               type="text"
//               placeholder="Enter city"
//               value={filters.city}
//               onChange={(e) => handleFilterChange("city", e.target.value)}
//               className="w-full border rounded-lg px-3 py-2"
//             />
//           </div>
//         </aside>

//         {/* Event Cards Grid */}
//         <div className="flex-1 relative">
//           {items.length ? (
//             <div className="relative">
//               <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6">
//                 {items.map((e) => (
//                   <EventCardNew key={e.id || e._id} item={e} />
//                 ))}
//               </div>

//               {/* FETCH OVERLAY (FancyLoader mini) */}
//               {fetching && (
//                 <div className="absolute inset-0 rounded-xl bg-white/60 backdrop-blur-[1px] flex items-center justify-center">
//                   <div className="scale-90">
//                     <FancyLoader label="Updating results..." />
//                   </div>
//                 </div>
//               )}
//             </div>
//           ) : (
//             <div className="p-6 rounded-xl bg-white">No featured events found.</div>
//           )}
//         </div>
//       </div>
//     </Section>
//   );
// }


// src/pages/FeaturedPage.jsx
import React, { useEffect, useMemo, useRef, useState } from "react";
import { useNavigate } from "react-router-dom";
import EventCardNew from "../components/EvetCardNew.jsx";
import { apiFeaturedAll } from "../api/events.js";
import { get } from "../lib/http";
import { API } from "../config/api";
import FancyLoader from "../components/FancyLoader.jsx";

const fieldClass =
  "w-full rounded-xl border border-slate-200/90 bg-white px-3 py-2.5 text-sm text-slate-900 shadow-sm outline-none transition placeholder:text-slate-400 focus:border-amber-400 focus:ring-2 focus:ring-amber-200/80";
const labelClass = "mb-1.5 block text-[11px] font-bold uppercase tracking-wide text-slate-500";

function FeaturedFiltersContent({ filters, onChange, fetching, categories, catLoading }) {
  return (
    <>
      <div className="mb-4">
        <label className={labelClass}>Search</label>
        <div className="relative">
          <input
            type="text"
            placeholder="Event, venue, city…"
            value={filters.search}
            onChange={(e) => onChange("search", e.target.value)}
            className={`${fieldClass} pr-9`}
          />
          {fetching && (
            <div className="absolute right-3 top-1/2 -translate-y-1/2">
              <div className="h-4 w-4 animate-spin rounded-full border-2 border-amber-400 border-t-transparent" />
            </div>
          )}
        </div>
      </div>

      <div className="mb-4">
        <label className={labelClass}>Category</label>
        <div className="relative">
          <select
            value={filters.category}
            onChange={(e) => onChange("category", e.target.value)}
            className={`${fieldClass} appearance-none pr-9`}
            disabled={catLoading}
          >
            <option value="">{catLoading ? "Loading…" : "All categories"}</option>
            {categories.map((c) => (
              <option key={c.id} value={c.value}>
                {c.name}
              </option>
            ))}
          </select>
          {catLoading && (
            <div className="pointer-events-none absolute right-3 top-1/2 -translate-y-1/2">
              <div className="h-4 w-4 animate-spin rounded-full border-2 border-amber-400 border-t-transparent" />
            </div>
          )}
        </div>
        {!catLoading && !categories.length ? (
          <p className="mt-1 text-xs text-slate-500">No categories from server.</p>
        ) : null}
      </div>

      <div className="mb-4">
        <label className={labelClass}>From date</label>
        <input
          type="date"
          value={filters.fromDate}
          onChange={(e) => onChange("fromDate", e.target.value)}
          className={fieldClass}
        />
        <label className={`${labelClass} mt-3`}>To date</label>
        <input
          type="date"
          value={filters.toDate}
          onChange={(e) => onChange("toDate", e.target.value)}
          className={fieldClass}
        />
      </div>

      <div>
        <label className={labelClass}>City</label>
        <input
          type="text"
          placeholder="e.g. Indore"
          value={filters.city}
          onChange={(e) => onChange("city", e.target.value)}
          className={fieldClass}
        />
      </div>
    </>
  );
}

export default function FeaturedPage() {
  const navigate = useNavigate();

  const [items, setItems] = useState([]);
  const [loading, setLoading] = useState(true);     // first mount loader
  const [fetching, setFetching] = useState(false);  // subsequent refetch overlay

  const [filters, setFilters] = useState({
    category: "",
    status: "",    // "upcoming" | "past" | ""
    city: "",
    search: "",
    fromDate: "",
    toDate: "",
  });

  // ------- Dynamic categories -------
  const [categories, setCategories] = useState([]);
  const [catLoading, setCatLoading] = useState(false);

  useEffect(() => {
    let alive = true;
    (async () => {
      try {
        setCatLoading(true);
        const token = JSON.parse(localStorage.getItem("bb_user"))?.token;
        const res = await get(API.category.category, {
          headers: {
            Authorization: token ? `Bearer ${token}` : undefined,
            "Content-Type": "application/json",
          },
        });
        if (!alive) return;
        const list = Array.isArray(res?.categories) ? res.categories : [];
        const normalized = list.map((c) => ({
          id: c._id,
          name: c.name || c.title || c.slug || "Unnamed",
          value: c._id, // change to c.name/slug if backend expects that
        }));
        setCategories(normalized);
      } catch (err) {
        console.error("categoryList error:", err);
        setCategories([]);
      } finally {
        setCatLoading(false);
      }
    })();
    return () => { alive = false; };
  }, []);

  // ------------- SINGLE debounced fetch effect (initial + subsequent) -------------
  const reqSeqRef = useRef(0);

  useEffect(() => {
    const t = setTimeout(async () => {
      const mySeq = ++reqSeqRef.current;
      if (reqSeqRef.current === 1) setLoading(true);
      setFetching(true);

      try {
        const payload = {
          ...filters,
          status: (filters.status || "").toLowerCase(), // ensure backend-friendly
        };
        const data = await apiFeaturedAll(payload);

        if (mySeq !== reqSeqRef.current) return; // stale response guard
        setItems(Array.isArray(data) ? data : []);
      } catch (e) {
        if (mySeq === reqSeqRef.current) {
          console.error("Filter/search fetch failed:", e);
          setItems([]);
        }
      } finally {
        if (mySeq === reqSeqRef.current) {
          setFetching(false);
          setLoading(false);
        }
      }
    }, 400);

    return () => clearTimeout(t);
  }, [filters]);

  // ---------------- handlers ----------------
  const handleFilterChange = (name, value) => {
    setFilters((prev) => ({ ...prev, [name]: value }));
  };

  const clearFilters = () => {
    setFilters({
      category: "",
      status: "",
      city: "",
      search: "",
      fromDate: "",
      toDate: "",
    });
  };

  const visibleItems = useMemo(() => {
    if (!Array.isArray(items)) return [];
    return items.filter((e) => {
      const s = String(e?.status || "").toLowerCase();
      return s !== "past" && s !== "ended" && s !== "cancelled";
    });
  }, [items]);

  // back handler (go back if possible, else go home)
  const goBack = () => {
    if (window.history.length > 1) navigate(-1);
    else navigate("/", { replace: true });
  };

  // ---------------- UI ----------------
  // FULL-PAGE loader on first mount (same feel as CheckoutPage)
  if (loading && !items.length) {
    return (
      <main className="grid w-full place-items-center px-4 py-10 font-sans">
        <FancyLoader label="Loading featured events…" />
      </main>
    );
  }

  return (
    <main className="min-h-screen w-full max-w-full overflow-x-clip bg-gradient-to-b from-amber-50/90 via-white to-slate-50 font-sans pb-12">
      <div className="mx-auto max-w-7xl px-3 py-6 sm:px-4 sm:py-8">
        <div className="mb-6 flex flex-col gap-4 sm:flex-row sm:items-end sm:justify-between">
          <div>
            <h1 className="text-2xl font-bold tracking-tight text-slate-900 md:text-3xl">
              Featured events
            </h1>
            <p className="mt-1 max-w-xl text-sm text-slate-600">
              Filter by city, dates, or category — then open any show for full details.
            </p>
          </div>
          <button
            type="button"
            onClick={goBack}
            className="inline-flex shrink-0 items-center gap-2 self-start rounded-xl border border-slate-200 bg-white px-4 py-2 text-sm font-semibold text-slate-800 shadow-sm transition hover:border-amber-300 hover:bg-amber-50/50 sm:self-auto"
            title="Go back"
          >
            <svg width="18" height="18" viewBox="0 0 24 24" fill="none" aria-hidden>
              <path
                d="M15 18l-6-6 6-6"
                stroke="currentColor"
                strokeWidth="2"
                strokeLinecap="round"
                strokeLinejoin="round"
              />
            </svg>
            Back
          </button>
        </div>

        <div className="flex flex-col gap-6 lg:flex-row lg:gap-8">
          {/* Mobile collapsible filters */}
          <details className="group rounded-2xl border border-slate-200/80 bg-white p-4 shadow-sm lg:hidden">
            <summary className="flex cursor-pointer list-none items-center justify-between gap-2 text-sm font-bold text-slate-900 [&::-webkit-details-marker]:hidden">
              <span>Filters</span>
              <span className="rounded-full bg-amber-100 px-2 py-0.5 text-xs font-semibold text-amber-900 group-open:hidden">
                Show
              </span>
              <span className="hidden text-xs font-semibold text-amber-800 group-open:inline">Hide</span>
            </summary>
            <div className="mt-4 border-t border-slate-100 pt-4">
              <div className="mb-4 flex justify-end">
                <button
                  type="button"
                  onClick={clearFilters}
                  className="text-sm font-semibold text-amber-800 hover:text-amber-950 hover:underline"
                >
                  Clear all
                </button>
              </div>
              <FeaturedFiltersContent
                filters={filters}
                onChange={handleFilterChange}
                fetching={fetching}
                categories={categories}
                catLoading={catLoading}
              />
            </div>
          </details>

          {/* Desktop sticky filters */}
          <aside className="hidden w-full max-w-sm shrink-0 lg:block">
            <div className="sticky top-24 rounded-2xl border border-slate-200/80 bg-white p-5 shadow-md">
              <div className="mb-4 flex items-center justify-between border-b border-slate-100 pb-3">
                <h3 className="text-base font-bold tracking-tight text-slate-900">Filters</h3>
                <button
                  type="button"
                  onClick={clearFilters}
                  className="text-sm font-semibold text-amber-800 hover:text-amber-950 hover:underline"
                >
                  Clear all
                </button>
              </div>
              <FeaturedFiltersContent
                filters={filters}
                onChange={handleFilterChange}
                fetching={fetching}
                categories={categories}
                catLoading={catLoading}
              />
            </div>
          </aside>

          <div className="relative min-w-0 flex-1">
            {visibleItems.length ? (
              <div className="relative">
                <p className="mb-4 text-sm text-slate-600">
                  Showing{" "}
                  <span className="font-semibold text-slate-900">{visibleItems.length}</span>{" "}
                  {visibleItems.length === 1 ? "event" : "events"}
                </p>
                <div className="grid grid-cols-1 gap-5 sm:grid-cols-2 sm:gap-6 xl:grid-cols-3 [&>*]:min-w-0">
                  {visibleItems.map((e) => (
                    <EventCardNew key={e._id || e.id} item={e} />
                  ))}
                </div>

                {fetching && (
                  <div className="absolute inset-0 flex items-center justify-center rounded-2xl bg-white/70 backdrop-blur-[2px]">
                    <div className="scale-90">
                      <FancyLoader label="Updating…" />
                    </div>
                  </div>
                )}
              </div>
            ) : (
              <div className="rounded-2xl border border-dashed border-amber-200/90 bg-white/80 px-6 py-14 text-center shadow-sm">
                <p className="text-base font-semibold text-slate-800">No events match these filters</p>
                <p className="mt-2 text-sm text-slate-600">Try clearing filters or widening the date range.</p>
                <button
                  type="button"
                  onClick={clearFilters}
                  className="mt-6 inline-flex rounded-xl bg-amber-400 px-5 py-2.5 text-sm font-bold text-slate-900 shadow-sm hover:bg-amber-300"
                >
                  Clear filters
                </button>
              </div>
            )}
          </div>
        </div>
      </div>
    </main>
  );
}
